/**
 * 系统app类型 (配置列表中的类型)
 */
enum AppSystemType {
    
    /** 内部Iframe模式 */
    潜入APP = 0,

    /** 新窗口打开的APP */
    弹出APP = 1,

    /** 内部功能 */
    核心功能 = 2,

    /** 内部功能 */
    潜入APP2 = 3,
}

export default AppSystemType;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/constant/AppSystemType/index.ts